import { File, FileEdit, Home, Search, Tag, Tags } from 'lucide-react';

export const MENU_NAVIGATION_ITEMS = [
  { label: 'Home', icon: Home, value: '/' },
  { label: 'Search', icon: Search, value: 'search' },
  { label: 'Collections', icon: Tags, value: 'collections' },
  { label: 'Products', icon: Tag, value: 'products' },
  { label: 'Pages', icon: File, value: 'pages' },
  { label: 'Blogs', icon: FileEdit, value: 'blogs' },
  { label: 'Blog Posts', icon: FileEdit, value: 'blog-posts' },
  { label: 'Terms Condition', icon: File, value: 'terms-condition' },
  { label: 'About Us', icon: File, value: 'about-us' },
  { label: 'Faq', icon: File, value: 'faq' },
];
